import React from 'react'

export const EditTabNameDisplay = React.createContext();